import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useAppDispatch } from '@/store';
import { createTier, updateTier } from '@/store/thunks/tierThunks';
import type { Tier } from '@/types';
import { Input, Button, Select } from '@/components/ui';

const schema = Yup.object({
  code: Yup.string().required('Code obligatoire'),
  nom: Yup.string().required('Nom obligatoire'),
  type: Yup.string().oneOf(['LOCATIER', 'FOURNISSEUR']).required('Type obligatoire'),
});

interface TierFormProps {
  tier?: Tier | null;
  type: 'create' | 'update';
  onClose: () => void;
  onSuccess?: () => void;
}

export default function TierForm({ tier, type, onClose, onSuccess }: TierFormProps) {
  const dispatch = useAppDispatch();

  const formik = useFormik({
    initialValues: {
      code: tier?.code ?? '',
      nom: tier?.nom ?? '',
      type: (tier?.type as string) ?? '',
    },
    validationSchema: schema,
    onSubmit: async (values) => {
      const payload = { ...values, type: values.type as Tier['type'] };
      if (type === 'update' && tier?.id) {
        const res = await dispatch(updateTier({ ...tier, ...payload }));
        if (updateTier.fulfilled.match(res)) {
          onSuccess?.();
          onClose();
        }
      } else {
        const res = await dispatch(createTier(payload));
        if (createTier.fulfilled.match(res)) {
          onSuccess?.();
          onClose();
        }
      }
    },
  });

  return (
    <form onSubmit={formik.handleSubmit} className="space-y-4">
      <Input
        label="Code"
        id="code"
        {...formik.getFieldProps('code')}
        error={formik.touched.code ? formik.errors.code : undefined}
      />
      <Input
        label="Nom"
        id="nom"
        {...formik.getFieldProps('nom')}
        error={formik.touched.nom ? formik.errors.nom : undefined}
      />
      <Select
        label="Type"
        id="type"
        options={[
          { value: 'LOCATIER', label: 'LOCATIER' },
          { value: 'FOURNISSEUR', label: 'FOURNISSEUR' },
        ]}
        {...formik.getFieldProps('type')}
        error={formik.touched.type ? formik.errors.type : undefined}
      />
      <div className="flex justify-end gap-2 pt-2">
        <Button type="button" variant="outline" onClick={onClose}>
          Annuler
        </Button>
        <Button type="submit" loading={formik.isSubmitting}>
          {type === 'update' ? 'Modifier' : 'Créer'}
        </Button>
      </div>
    </form>
  );
}
